import * as a from '@mitranim/js/all.mjs'
import * as c from './conf.mjs'
import * as ug from './util-gtag.mjs'

export function hasAnalytDataset(val) {
  const src = a.optElement(val)?.dataset
  return !!(src?.actInp || src.gtagInp)
}

export function analytDataset(src) {
  if (!a.optDict(src)) return undefined
  const actInp = a.optDict(src.actInp)
  const gtagInp = a.optArr(src.gtagInp)
  if (!actInp && !gtagInp) return undefined

  return {
    actInp: a.jsonEncode(actInp),
    gtagInp: a.jsonEncode(gtagInp),
  }
}

export function elemActInp(src) {
  return a.optDict(a.jsonDecode(a.optElement(src)?.dataset?.actInp))
}

export function elemGtagInp(src) {
  return a.optArr(a.jsonDecode(a.optElement(src)?.dataset?.gtagInp))
}

export function analytDatasetForView({uiKind, ent}) {
  a.reqValidStr(uiKind)
  if (!a.optObj(ent)) return undefined

  const actInp = a.vac(c.ENABLE_ACTS) && a.optDict(ent.actInp?.())
  if (actInp) actInp.uiKind = uiKind

  const gtagOpt = ug.gtagItemsOptFromEnt(ent)
  if (gtagOpt) gtagOpt.item_list_name = uiKind

  return analytDataset({
    actInp,
    gtagInp: a.vac(gtagOpt) && [c.GTAG_EVENT_VIEW_ITEM, gtagOpt],
  })
}

/*
References:

  https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#view_item_list
  https://developers.google.com/tag-platform/gtagjs/reference/events#view_item_list

Note: we're not bothering to create our own `acts` for viewing a feed, because
that's redundant with viewing feed items. Gtag makes no distinction between
viewing ent preview vs viewing ent details, which is why they need a separate
event for viewing a feed. We make that distinction, so we don't need an event
for viewing a feed.
*/
export function gtagInpViewItemList(ents) {
  const opt = ug.gtagItemsOptFromEnts(ents)
  if (!opt) return undefined
  opt.item_list_name = opt.entType
  return [c.GTAG_EVENT_VIEW_ITEM_LIST, opt]
}
